const color: any = {
  mainColor: "#111829",
  pointColor: "#6082ef",
  lightGrey: "rgb(247, 247, 247)",
};

export default color;
